import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { TelemetryContext } from '../telemetryContext';
import { createApplicationInsightsLogger } from '../loggers/applicationInsightsLogger';
import { createLocalhostLogger } from '../loggers/localhostLogger';
import { Logger } from '../loggers/Logger';

function TelemetryServiceProvider({ children, history }) {
    let [logger, setLogger] = useState<Logger | null>(null);

    useEffect(() => {
        let isProduction = window.appConfig.env === 'production';
        if (!logger) {
            let _logger = isProduction
                ? createApplicationInsightsLogger(history)
                : createLocalhostLogger();

            window.logger = _logger;

            setLogger(_logger);
        }
    }, [logger]);

    if (!children) {
        throw new Error(
            'TelemetryServiceProvider used without passing any children! That will result in not being able to access the logger from TelemetryContext.'
        );
    }

    return <TelemetryContext.Provider value={{ logger }}>{children}</TelemetryContext.Provider>;
}

// @ts-ignore
export default withRouter(TelemetryServiceProvider);
